import React, { Component } from "react";

import { CCard, CCardBody, CCardHeader } from "@coreui/react";
import { connect } from "react-redux";
import SortableTree from "react-sortable-tree";
import { bindActionCreators } from "redux";

import { logout, getMenuItens } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import Modal from "../../../../components/Modal/Modal";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "react-sortable-tree/style.css";
import "./styles.css";

class MenuList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [],
      loading: true,
      loadingInternal: false,
      // newNode: {},
      // newItens: [],
      modal: false,
      called: {}
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.createNewElement = this.createNewElement.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.getInfos();
  }

  getInfos = () => {
    axios
      .get(`${URL.api}configuration/menu/listMenu`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let { menu } = resp.data.data;
        let components = resp.data.data.routes;

        menu.forEach((primary, idp) => {
          menu[idp].title = primary.name;
          menu[idp].expanded = true;
          if (primary.children) {
            primary.children.forEach((secondary, ids) => {
              menu[idp].children[ids].title = secondary.name;
              menu[idp].children[ids].expanded = true;
              if (secondary.children) {
                secondary.children.forEach((third, idt) => {
                  menu[idp].children[ids].children[idt].title = third.name;
                  menu[idp].children[ids].children[idt].expanded = true;
                });
              }
            });
          }
        });
        components.forEach((component, idc) => {
          components[idc].value = component.id;
        });
        let menuFather = {
          title: "menu",
          id: 0,
          children: menu,
          expanded: true
        };
        this.setState(
          () => ({
            menu: [menuFather],
            components
          }),
          () => {
            this.setState(() => ({
              loading: false
            }));
          }
        );
      });
  };

  moveElement = elem => {
    let father = elem.nextParentNode;
    let { menu } = this.state;

    let reorder;
    menu.forEach((primary, idp) => {
      if (primary.id === father.id) {
        reorder = primary.children;
      }
      if (primary.children) {
        primary.children.forEach((secondary, ids) => {
          if (secondary.id === father.id) {
            reorder = secondary.children;
          }
          if (secondary.children) {
            secondary.children.forEach((third, idt) => {
              if (third.id === father.id) {
                reorder = third.children;
              }
            });
          }
        });
      }
    });
    reorder.forEach((elem, idx) => {
      elem.order = idx + 1;
    });
    reorder.forEach(elem => {
      this.setState({
        loadingInternal: true
      });
      elem.menu_id = father.id;
      if (elem.menu_id === 0) {
        elem.menu_id = null;
      }
      elem.loggedUser = this.props.user.user.id;
      axios
        .post(`${URL.api}configuration/menu/update/${elem.id}`, elem, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState({
            loadingInternal: false
          });
        });
    });
  };

  insertBtn = rowInfo => {
    if (rowInfo.path.length === 1) {
      return {
        buttons: [
          <button
            className="btn-menu-create btn btn-primary"
            onClick={() => this.toggleModal(rowInfo)}
          >
            +
          </button>
        ]
      };
    }
    if (rowInfo.path.length !== 4) {
      return {
        buttons: [
          <button
            className="btn-menu-create btn btn-primary"
            onClick={() => this.toggleModal(rowInfo)}
          >
            +
          </button>,
          <button
            className="btn-menu-create btn btn-warning"
            onClick={() => this.toggleModal(rowInfo, true)}
          >
            <i className="fa fa-pencil"></i>
          </button>,
          <button
            className="btn-menu-create btn btn-danger"
            onClick={() => this.delete(rowInfo)}
          >
            -
          </button>
        ]
      };
    }
    return {
      buttons: [
        <button
          className="btn-menu-create btn btn-warning"
          onClick={() => this.toggleModal(rowInfo, true)}
        >
          <i className="fa fa-pencil"></i>
        </button>,
        <button
          className="btn-menu-create btn btn-danger"
          onClick={() => this.delete(rowInfo)}
        >
          -
        </button>
      ]
    };
  };

  delete(rowInfo) {
    let del = rowInfo.node;
    del.loggedUser = this.props.user.user.id;

    axios
      .post(`${URL.api}configuration/menu/delete`, del, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.getInfos();
      });
  }

  toggleModal(rowInfo, edit = false) {
    this.setState(
      {
        // eslint-disable-next-line react/no-access-state-in-setstate
        modal: !this.state.modal
      },
      () => {
        if (this.state.modal) {
          if (rowInfo.node.children) {
            this.setState({
              called: {
                id: rowInfo.node.id,
                maxChildren: rowInfo.node.children.length,
                edit,
                node: rowInfo.node
              }
            });
          } else {
            this.setState({
              called: {
                id: rowInfo.node.id,
                maxChildren: 0,
                edit,
                node: rowInfo.node
              }
            });
          }
        }
      }
    );
  }

  createNewElement = value => {
    const { components } = this.state;
    let path;
    components.forEach(component => {
      if (component.id === parseInt(value.link)) {
        path = component.path;
      }
    });
    let newElement = {
      name: value.name,
      icon: value.icon,
      link_id: parseInt(value.link),
      path,
      menu_id: this.state.called.id,
      order: parseInt(this.state.called.maxChildren) + 1,
      loggedUser: this.props.user.user.id
    };
    axios
      .post(`${URL.api}menu/insert`, newElement, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.getInfos();
        this.props.getMenuItens(
          this.props.user,
          this.props.general.active_roles.role_id
        );
        this.toggleModal();
      });
  };

  editElement = value => {
    const { components } = this.state;
    let path;
    components.forEach(component => {
      if (component.id === parseInt(value.link)) {
        path = component.path;
      }
    });
    let editElement = {
      name: value.name,
      icon: value.icon,
      link_id: parseInt(value.link),
      path,
      loggedUser: this.props.user.user.id
    };
    axios
      .post(
        `${URL.api}configuration/menu/update/${this.state.called.node.id}`,
        editElement,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        this.setState(
          {
            called: {}
          },
          () => {
            this.getInfos();
            this.props.getMenuItens(
              this.props.user,
              this.props.general.active_roles.role_id
            );
            this.toggleModal();
          }
        );
      });
  };

  render() {
    const Fields = [
      {
        name: "name",
        label: "Name -  Ex.:Configuração",
        type: "text",
        required: true,
        icon: "fa fa-user"
      },
      {
        name: "icon",
        label: "Icon -  Ex.: fa fa-user",
        type: "text",
        required: true,
        icon: "fa fa-user"
      },
      {
        name: "link",
        label: "Component -  Ex.:",
        type: "select",
        required: true,
        icon: "fa fa-user",
        options: this.state.components
      }
    ];

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <h4 className="card-title mb-1">Menus</h4>
              <div className="small text-muted">
                Crie, edite ou apague itens da estrutura do menu
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            {this.state.loading ? (
              <Loading top="45" left="50" />
            ) : (
              <React.Fragment>
                <div className="menuTreeArea">
                  <SortableTree
                    treeData={this.state.menu}
                    toggleExpandedForAll
                    onChange={treeData => this.setState({ menu: treeData })}
                    onMoveNode={this.moveElement}
                    generateNodeProps={this.insertBtn}
                    isVirtualized={false}
                  />
                </div>
                {this.state.loadingInternal ? (
                  <Loading top="45" left="50" />
                ) : (
                  ""
                )}
                {this.state.called.edit ? (
                  <Modal
                    toggleModal={this.toggleModal}
                    modalState={this.state.modal}
                    title="Novo item de menu"
                    className=" educandus"
                    loading
                    body="texto"
                    form={Fields}
                    initialValues={this.state.called.node}
                    action={this.editElement}
                  />
                ) : (
                  <Modal
                    toggleModal={this.toggleModal}
                    modalState={this.state.modal}
                    title="Novo item de menu"
                    className=" educandus"
                    loading
                    body="texto"
                    form={Fields}
                    action={this.createNewElement}
                  />
                )}
              </React.Fragment>
            )}
          </CCardBody>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </CCard>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      getMenuItens,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuList);
